if (!customElements.get('zano-promo-video')) {
  class ZanoPromoVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.setAttribute('muted', '');
      this.video.removeAttribute('controls');

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.showStill();
        return;
      }

      // Autoplays (muted, looping) while on screen, desktop and mobile; pauses when scrolled away to save data.
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        if (visible) {
          this.tryPlay();
        } else if (!this.still) {
          this.video.pause();
        }
      }, { rootMargin: '160px 0px', threshold: 0.1 });
      this.observer.observe(this);
    }

    tryPlay() {
      if (this.still) return;
      const p = this.video.play();
      if (p && p.catch) {
        p.catch(() => this.showStill());
      }
    }

    // If the browser blocks autoplay (e.g. Safari settings, Low Power Mode), show a still frame instead of a play button.
    showStill() {
      if (this.still) return;
      this.still = true;
      const poster = this.video.getAttribute('poster');
      if (!poster) return;
      const img = document.createElement('img');
      img.src = poster;
      img.alt = '';
      img.className = 'zano-promo-video__video';
      img.setAttribute('aria-hidden', 'true');
      this.video.pause();
      this.video.replaceWith(img);
      this.observer?.disconnect();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('zano-promo-video', ZanoPromoVideo);
}
